module.exports = "/images/plane.svg?bb2092034ace03d6b6650e45d7fce66e";